module.exports = __webpack_public_path__ + "img/po4.b758419d.jpg";